import { useHandler } from 'hooks/useHandler';

import * as State from './State';

export default function useState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			initialize: rf.createReducerAsync(State.initialize),
			setCurrentKnowledgeBaseId: rf.createReducer(State.setCurrentKnowledgeBaseId),
			uploadDocument: rf.createReducerAsync(State.uploadDocument),
			createAndSetFile: rf.createReducer(State.createAndSetFile),
			deleteDocument: rf.createReducerAsync(State.deleteDocument),
			parseDocument: rf.createReducerAsync(State.parseDocument),
			stopParsingDocument: rf.createReducerAsync(State.stopParsingDocument),
		},
	};
}

export type Handlers = ReturnType<typeof useState>['handlers'];
